import React from 'react';
import PopUp from 'reactjs-popup';
import { IconSVG } from '../../../../IconSVG';
import { DropdownOptions } from './DropdownOptions';
import './DataGridDropdownEllipsis.scss';
export const DataGridDropdownEllipsis = ({ options, handleOptionSelection, }) => {
    const [optionsVisible, setOptionsVisible] = React.useState(false);
    const onOptionClick = (event) => {
        if (!event.currentTarget)
            return;
        // cannot find getAttribute method
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        handleOptionSelection(event.currentTarget.getAttribute('data-value'));
    };
    const showOptions = () => setOptionsVisible(true);
    const EllipsisControl = React.useCallback(() => (React.createElement("div", { onMouseEnter: showOptions },
        React.createElement(IconSVG, { iconType: "Ellipsis", style: {
                width: '25px',
                height: '25px',
            } }))), []);
    return (React.createElement(PopUp, { trigger: EllipsisControl, open: optionsVisible, arrow: true, offsetY: -20, on: "hover" },
        React.createElement("div", { className: "dropdown-wrapper-grid" },
            React.createElement(DropdownOptions, { options: options, onOptionClick: onOptionClick }))));
};
//# sourceMappingURL=DataGridDropdownEllipsis.js.map